// Digital Library videos are transcoded server-side into the HLS renditions
// Api.hlsUrl serves, after the raw upload itself lands on S3 - the same processing
// step the schedule module's resource videos go through (see
// src/pages/schedule/ScheduleDetailsDrawer.js).
//
// A freshly uploaded video's row comes back as status 'Draft' and stays 'Draft'
// until the transcode finishes, so "it showed up in the list" can't be read as
// "it's ready to play" - the card would offer a video for playback that the player
// can't yet resolve (outright impossible for the .flv/.avi/.mkv uploads
// UploadPdf.js accepts, which no browser can decode raw).
//
// The listing response is the only thing this needs to read, which means an upload
// made from the mobile app shows as processing on the web exactly like one made
// here - there is no client-side bookkeeping that only knows about its own uploads.

/**
 * Is this video row still being transcoded, i.e. not yet playable?
 *
 *  - 'Draft' is the transcoding state: the row exists, the file is on S3, the
 *    renditions aren't ready. Shown as "Processing..", and not openable.
 *  - Anything else - 'Published' above all - means the transcode is done and the
 *    card shows no status at all.
 *  - An external link (YouTube, Drive, a direct video URL) has no uploaded file
 *    behind it, so there is nothing to transcode and it's playable as soon as it's
 *    saved - the same carve-out the schedule module makes for YouTube resources.
 */
export const isVideoProcessing = (item) => {
  if (!item) return false;
  if (item.link) return false;
  return item.status === 'Draft';
};
